import React, { Component } from 'react';

export default class Notification extends Component {

	constructor(){
		super()

		this.mapsApi = process.env.REACT_APP_GEO_API

		this.state = {
			title: null,
			message: null,
			location: null,
			forAll: false,
			query:{
				"eat": false,
				"play": false,
				"parents": false,
				"$or": []
			},
			infant: false,
			toddler: false,
			pre_teen: false,
			teen: false,
			adult: false,
			formatted_address: null,
			forAll: false,
			forRegion: true,
			forRegionPersonalized: false
		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.getCoords = this.getCoords.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	async handleSubmit(e){
		e.persist();
		e.preventDefault();

		let data = this.state

		// remove all query items that are
		var keys = Object.keys(data.query)

		keys.forEach(key => {

			if(!data.query[key]){
				delete data.query[key]
			}

		});

		const url = "https://us-central1-funily-deals.cloudfunctions.net/FCMNotification";
		let options = {
			method: "Post",
			body: JSON.stringify(data)
		}


		// reset state
		this.setState({
			title: null,
			message: null,
			location: null,
			forAll: false,
			query:{
				"eat": false,
				"play": false,
				"parents": false,
				"$or": []
			},
			infant: false,
			toddler: false,
			pre_teen: false,
			teen: false,
			adult: false,
			formatted_address: null,
			forAll: false,
			forRegion: true,
			forRegionPersonalized: false
		}, async () => {

			console.log('data for notification',data);

			try {

				let sendNotification = await fetch(url,options);
				let jsonRes = await sendNotification.json();

				console.log('jsonRes from Notification',jsonRes);

			} catch (e) {

				throw e;

			}


		})

		e.target.reset();
	}

	getCoords(e){

		let zip = e.target.value;

		let api = 'https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:'+zip+'&key=' + this.mapsApi;

		if(zip.length > 4){

			fetch(api)
		    .then(result => {
		      return result.json()
		    })
		    .then(function(jsonResponse) {

		      let status = jsonResponse.status;

		      //  if zip code is invalid
		      if(status != "OK"){
		      	this.setState({invalidZip: true, formatted_address: 'Invalid Zip Code'})
		      }

		      if(status == 'OK'){
		      	let formatted_address = jsonResponse.results[0].formatted_address
		      	let city = jsonResponse.results[0].address_components[1].long_name
		      	console.log(city);
		      	let geLoc = jsonResponse.results[0].geometry.location
			    let location = [geLoc.lat,geLoc.lng]
			    this.setState({ location, formatted_address, city },() => {
			    	console.log(this.state);
			    })//setState
		      }

		    }.bind(this))
		    .catch(error => console.log('geocode failed: ', error));

		}

	}

	handleChange(e){
		var key = e.target.name;
		var val = e.target.value;
		let data = this.state;

		switch(key){
			case 'title':
				this.setState({title: val});
				break;

			case 'message':
				this.setState({message: val});
				break;

			case 'forAll':
				this.setState({forAll: !this.state.forAll})
				break;

			case 'forRegion':
				this.setState({forRegion: !this.state.forRegion})
				break;

			case 'forRegionPersonalized':
				this.setState({forRegionPersonalized: !this.state.forRegionPersonalized})
				break;

			case 'play':

			case 'eat':

			case 'parents':
				data.query[key] = !data.query[key]
				this.setState({...data});
				break;

			case 'infant':

			case 'toddler':

			case 'pre_teen':

			case 'teen':

			case 'adult':

				data.query["$or"].push({[key]:true})
				data[key] = !data[key]
				this.setState({...data});
				break;

			default:
			break;
		}
	}

	render() {
		let { forAll, forRegion } = this.state
		return (
			<div className='col-md-4 col-md-offset-4' style={styles.container}>

				<div style={{flex: 1}}>
					<h1 className='text-center text-primary'>Send Notifications</h1>

					<form onSubmit={this.handleSubmit}>

						<div className='form-group'>
							<input type='checkbox'
								   id='forAll'
								   checked={ this.state.forAll }
								   ref='forAll'
								   name='forAll'
								   value='forAll'
								   onChange={this.handleChange}
								   disabled={this.state.forRegion}
								   />
							<span style={{padding: '10px'}}>Send to ALL devices</span>
						</div>

						<div className='form-group'>
							<input type='checkbox'
								   id='forRegion'
								   checked={ this.state.forRegion }
								   ref='forRegion'
								   name='forRegion'
								   value='forRegion'
								   onChange={this.handleChange}
								   disabled={this.state.forAll}
								   />
							<span style={{padding: '10px'}}>Regional Message All</span>
						</div>
						{/**
						<div className='form-group'>
							<input type='checkbox'
								   id='forRegionPersonalized'
								   checked={ this.state.forRegionPersonalized }
								   ref='forRegionPersonalized'
								   name='forRegionPersonalized'
								   value='forRegionPersonalized'
								   onChange={this.handleChange}
								   disabled={this.state.forAll}
								   />
							<span style={{padding: '10px'}}>Personalized Regional Message</span>
						</div>
						**/}

						{
							forAll ? null
							: <div className='form-group'>
								<p style={{color: 'red'}}>{this.state.city ? this.state.city : null}</p>
							<input
								className='form-control'
								type='text'
								onBlur={this.getCoords}
								ref='address'
								placeholder='Enter Regional Zip Code'  />
							</div>
						}

						<div className='form-group'>
						<input className='form-control'
							   type='text'
							   ref='title'
							   name='title'
							   onChange={this.handleChange}
							   onBlur={this.handleChange}
							   placeholder='Title'
							   required/>
						</div>
						<div className='form-group'>
						<input className='form-control'
							   type='text'
							   ref='message'
							   name='message'
							   onChange={this.handleChange}
							   onBlur={this.handleChange}
							   placeholder='Message'
							   required/>
						</div>


						{/**
							forAll ? null
							: forRegion ? null
							:

							( <div>
								<h4>Category</h4>

								<div className='form-group'>
									<input type='checkbox'
									id='play' ref='play'
									name='play'
									value='play'
									checked={this.state.query.play}
									onChange={this.handleChange} />
									<span style={{padding: '10px'}}>Play</span>
								</div>

								<div className='form-group'>
									<input type='checkbox'
									id='eat'
									ref='eat'
									value='eat'
									name='eat'
									checked={this.state.query.eat}
									onChange={this.handleChange}  />
									<span style={{padding: '10px'}}>Eat</span>
								</div>

								<div className='form-group'>
									<input type='checkbox'
									id='parents'
									ref='parents'
									name='parents'
									checked={this.state.query.parents}
									onChange={this.handleChange} />
									<span style={{padding: '10px'}}>Parents' Night Out</span>
								</div>

								<h4>Age Group</h4>

								<div className='form-group'>
									<input type='checkbox'
									id='infant'
									ref='infant'
									value='infant'
									name='infant'
									checked={this.state.infant}
									onChange={this.handleChange} />
									<span style={{padding: '10px'}}>Infant</span>
								</div>

								<div className='form-group'>
									<input type='checkbox'
									id='toddler'
									ref='toddler'
									value='toddler'
									name='toddler'
									checked={this.state.toddler}
									onChange={this.handleChange} />
									<span style={{padding: '10px'}}>Toddler</span>
								</div>

								<div className='form-group'>
									<input type='checkbox'
									id='pre_teen'
									ref='pre_teen'
									value='pre_teen'
									name='pre_teen'
									checked={this.state.pre_teen}
									onChange={this.handleChange} />
									<span style={{padding: '10px'}}>Pre-Teen</span>
								</div>

								<div className='form-group'>
									<input type='checkbox'
									id='teen'
									ref='teen'
									value='teen'
									name='teen'
									checked={this.state.teen}
									onChange={this.handleChange} />
									<span style={{padding: '10px'}}>Teen</span>
								</div>

								<div className='form-group'>
									<input type='checkbox'
									id='adult'
									ref='adult'
									value='adult'
									name='adult'
									checked={this.state.adult}
									onChange={this.handleChange} />
									<span style={{padding: '10px'}}>Adult</span>
								</div>
							</div>
							)
						**/}




						<button className='btn btn-info btn-block' type='submit'>Send Message</button>
					</form>

				</div>

			</div>
		);
	}
}

const styles = {
	container: {
		display: 'flex',
		justifyContent: "center",
		paddingTop: "20px",
		marginTop: 100
	}
}



// WEBPACK FOOTER //
// ./src/components/admin/Notification.js